/**
 * XRDeviceAdapter — v10.9.0
 * Interfaz base para adaptadores XR. Los clientes futuros (Meta Quest,
 * XREAL, Unity/AR Foundation) implementan esta interfaz manteniendo la
 * lógica de SimuClinic 100% en backend.
 *
 * Contrato:
 *   - `capabilities()`: retorna las flags soportadas por el dispositivo actual
 *   - `startMarkerTracking(handlers)`: inicia detección; llama `handlers.onMarker(payload)` en cada detección
 *   - `stopMarkerTracking()`: cleanup
 *   - `getVideoElement()`: opcional — devuelve el <video> que hostea el stream (para render)
 *   - `showOverlay(overlay)`: opcional — API de overlay para futuros SDK
 */
export class XRDeviceAdapter {
  constructor({ deviceType = 'unknown', deviceName = null } = {}) {
    this.deviceType = deviceType;
    this.deviceName = deviceName;
  }

  static get id() { return 'base'; }

  async capabilities() {
    return {
      camera_supported: false,
      marker_tracking_supported: false,
      webxr_supported: false,
      depth_supported: false,
      spatial_anchor_supported: false,
      hand_tracking_supported: false,
      voice_supported: false,
    };
  }

  async startMarkerTracking(_handlers) {
    throw new Error('startMarkerTracking not implemented');
  }

  async stopMarkerTracking() {
    // no-op default
  }

  getVideoElement() { return null; }

  showOverlay(_overlay) { /* no-op */ }
}
